import moment from "moment";
import PropTypes from "prop-types";
import React, { Fragment, useState } from "react";
import { Button, Image, Modal, Form } from "react-bootstrap";
import { CircularProgressbar } from "react-circular-progressbar";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import {
  blockUserFromDetailPage,
  flagUserFromDetailPage,
} from "../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { FormControl, Select, InputLabel, MenuItem } from "@material-ui/core";
//import { SuperAdminCall } from "../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminCall";
import CallingButtonPopup from "../../../reusableComponents/allPopupReusable/CallingButtonPopup";
//import { ToggleButtonWithYesNo } from "../../../vendorOnboradingComponents/allScreens/NewSubscriptionScreen/AllButton/ToggleButtonReuse";
import SlidingComponent from "../../../reusableComponents/slidingToggleComponent/SlidingComponent";
import CustomSuperAdminNotification from "../../superAdminReusable/reusablePopupSuperAdmin/CustomSuperAdminNotification";
import CustomSuperAdminResetPassword from "../../superAdminReusable/reusablePopupSuperAdmin/CustomSuperAdminResetPassword";
// /import SuperAdminSmsAdmin from "../../superAdminReusable/";
import SuperAdminSmsAdmin from "../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminSmsAdmin";
import SuperAdminChatWindowPopup from "../superAdminPendingVendors/SuperAdminChatWindowPopup";
import {
  userReasonForBlock,
  userReasonForFlag,
} from "../../../../enums/GlobalEnums";
import { TextAreaReusableComponent } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";

const UserModal = (props) => {
  //usermodal
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const [showBlockUser, seShowBlockUser] = useState(false);
  const handleCloseBlockUser = () => seShowBlockUser(false);
  const handleShowBlockUser = () => seShowBlockUser(true);
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });
  const onSuccessBlock = () => {
    handleCloseBlockUser();
    handleCloseFlag();
  };

  const blockUser = (id, status) => {
    let data = {
      blockReason: reason.blockReason,
      blockComments: reason.blockComments,
    };
    data.user_blocked = !status;
    props.blockUserFromDetailPage(id, data, onSuccessBlock);
  };

  const calcProfile = (profilePercent) => {
    if (profilePercent) {
      return profilePercent + "%";
    } else {
      return "0%";
    }
  };
  const [showFlag, seShowFlag] = useState(false);
  const handleCloseFlag = () => {
    setStage(0);
    seShowFlag(false);
  };

  const [stage, setStage] = useState(0);
  const [reason, setReason] = useState({
    flagReason: "Junk User (No Transactions for <90 days)",
    blockReason: "Multiple cancellations",
  });

  const changeStage = (e) => {
    setStage(e);
  };

  const handleShowFlag = () => seShowFlag(true);

  const handleFlagUser = (id, status) => {
    let data = {
      flagReason: reason.flagReason,
      flagComments: reason.flagComments,
    };
    data.isFlag = !status;
    props.flagUserFromDetailPage(id, data, onSuccessBlock);
  };

  const makeCallingObject = (user) => {
    let formData = {};
    formData.user_details = {};
    formData.user_details.mobile_number = user.mobile_number;
    formData.user_details.country_code = user.country_code;
    formData.user_details.name = user.first_name;

    return formData;
  };

  return (
    <Fragment>
      <tbody>
        <tr className="super_admin_all_users_table_body">
          <td colSpan="7" className="p-0 w-100">
            <table className="w-100 HideShowTable">
              <tbody>
                <tr className="cursor" onClick={showTr}>
                  <td style={{ width: "20%" }}>
                    <div className="f15-500 mb-1">{`${props.user.first_name} ${props.user.last_name || ""
                      }`}</div>
                    <div className="f13-400 text-break">#{props.user._id}</div>
                  </td>
                  <td style={{ width: "15%" }}>
                    <div className="f15-500">
                      {props.user && props.user.city ? props.user.city : "N/A"}
                    </div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="f15-500">
                      {props?.user?.statsId?.diners || 0} <br />
                      {props?.user?.statsId?.orders || 0}
                    </div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="f15-500">
                      {props?.user?.statsId?.events || 0} <br />
                      {props?.user?.statsId?.scanAndPay || 0}
                    </div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="f15-500">
                      {props?.user?.statsId?.favs || 0} <br />
                      {props?.user?.statsId?.reviews}
                    </div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="f15-500">
                      {props?.user?.referredBy?.referee_id_Role || " - "}
                    </div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="progressCircleTbl">
                      <CircularProgressbar
                        value={
                          props.user && props.user.profile_percentage
                            ? props.user.profile_percentage
                            : 0
                        }
                        text={calcProfile(
                          props.user && props.user.profile_percentage
                        )}
                      />
                    </div>
                  </td>
                  <td style={{ width: "15%" }}>
                    <div className="f15-500 mb-1">
                      {props?.user?.last_activity_date ? moment(props?.user?.last_activity_date).format("Do MMMM YYYY") : '-'}
                    </div>
                    <div className="f15-500 mb-1">
                      {props?.user?.last_activity_date ? moment(props?.user?.last_activity_date).format("hh:mm A") : "-"}
                    </div>

                    <div className="f11-400">
                      {/* {moment(props.user.updatedAt).startOf("day").fromNow()} */}
                      {moment(props.user.updatedAt).fromNow()}
                    </div>
                  </td>
                </tr>
                {TrDetail.TrDetail && (
                  <tr className="border-top">
                    <td style={{ width: "25%" }}>
                      <div className="mb-2 f15-700">Device Specification</div>
                      <div className="f15-500 mb-1 text-break">
                        {props?.user?.deviceId || "-"}
                      </div>
                      {/* <div className="f11-400">
                        {props.user.country_code} {props.user.mobile_number}
                      </div> */}
                    </td>
                    <td style={{ width: "25%" }}>
                      <div className="mb-2 f15-700">Email/Phone</div>
                      <div className="f15-500 mb-1 text-break">
                        {props.user.email}
                      </div>
                      <div className="f11-400">
                        {props.user.country_code} {props.user.mobile_number}
                      </div>
                    </td>
                    <td style={{ width: "20%" }}>
                      <div className="mb-2 f15-700">Member Since</div>
                      <div className="f15-500 mb-1 text-break">
                        {moment(props?.user?.createdAt).format("ll")}
                      </div>
                    </td>
                    <td colSpan="2" style={{ width: "25%" }}>
                      <div className="mb-2 f15-700">Actions</div>
                      <div className="d-flex align-items-center">
                        <Button
                          variant="link"
                          className="enIconBtn mr-3"
                          onClick={(e) => props.handleShowEdit(props.user)}
                        >
                          <Image
                            src={require("../../../../assets/images/UserManagement/pencil.svg")}
                            alt="Edit"
                            title="Edit User"
                            fluid
                          />
                        </Button>

                        <React.Fragment>
                          <Button
                            variant="link"
                            //className="enIconBtn mr-3"
                            onClick={handleShowFlag}
                            className={
                              props.user.isFlag
                                ? "border-0 enIconBtn mr-3"
                                : "enIconBtn mr-3"
                            }
                          >
                            <Image
                              src={require("../../../../assets/images/UserManagement/flag.svg")}
                              alt="Flag User"
                              title="Flag User"
                              fluid
                            />
                          </Button>
                          <Modal
                            show={showFlag}
                            onHide={handleCloseFlag}
                            centered
                          >
                            <Modal.Header
                              className="py-0 pt-2 border-0"
                              closeButton
                            >
                              <Modal.Title></Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="f16-500">
                              Are you sure to{" "}
                              {props.user.isFlag ? "Unflag" : "Flag"} the user ?
                            </Modal.Body>
                            <Modal.Footer className="justify-content-start border-0">
                              <Button
                                variant="outline-secondary"
                                className="btn-lg mr-4 px-5"
                                onClick={handleCloseFlag}
                              >
                                No
                              </Button>
                              <Button
                                variant="danger"
                                className="btn-lg px-5"
                                onClick={() =>
                                  handleFlagUser(
                                    props.user._id,
                                    props.user.isFlag
                                  )
                                }
                              >
                                Yes
                              </Button>
                            </Modal.Footer>
                          </Modal>
                        </React.Fragment>
                        {!props.user.isSocialSignUp ? (
                          <CustomSuperAdminResetPassword
                            mobileNo={props.user.mobile_number}
                            countryCode={props.user.country_code}
                            name={props.user.first_name}
                            lastName={props.user.last_name}
                            userId={props.user._id}
                          />
                        ) : (
                          <> </>
                        )}
                        <React.Fragment>
                          <Button
                            variant="link"
                            className={
                              props.user.user_blocked
                                ? "border-0 enIconBtn mr-3 action_icon_padding p-15px"
                                : "enIconBtn mr-3"
                            }
                            onClick={handleShowBlockUser}
                          >
                            <Image
                              src={
                                props.user.user_blocked
                                  ? require("../../../../assets/images/ActionImages/image/block.svg")
                                  : require("../../../../assets/images/UserManagement/BlockContact.svg")
                              }
                              alt="Block User"
                              title="Block User"
                              fluid
                            />
                          </Button>
                          <Modal
                            show={showBlockUser}
                            onHide={handleCloseBlockUser}
                            centered
                          >
                            <Modal.Header
                              className="py-0 pt-2 border-0"
                              closeButton
                            >
                              <Modal.Title>
                                {" "}
                                {stage === 1 ? (
                                  <>Reason for Blocking a User</>
                                ) : (
                                  <></>
                                )}
                              </Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="f16-500">
                              {stage !== 1 ? (
                                <>
                                  Are you sure to{" "}
                                  {props.user.user_blocked
                                    ? "Unblock"
                                    : "Block"}{" "}
                                  the user ?
                                </>
                              ) : (
                                <></>
                              )}
                              {stage === 1 ? (
                                <>
                                  <Form.Group>
                                    <FormControl
                                      variant="outlined"
                                      className="w-100"
                                    >
                                      <InputLabel htmlFor="outlined-Status"></InputLabel>
                                      <Select
                                        value={
                                          reason.blockReason ||
                                          "Junk User (No Transactions for <90 days)"
                                        }
                                        onChange={(e) =>
                                          setReason({
                                            ...reason,
                                            blockReason: e.target.value,
                                          })
                                        }
                                        label=""
                                        inputProps={{
                                          name: "",
                                          id: "outlined-Status",
                                        }}
                                        IconComponent={KeyboardArrowDownIcon}
                                      >
                                        {userReasonForBlock.map(
                                          (item, index) => (
                                            <MenuItem
                                              label={item.title}
                                              value={item.value}
                                              key={item.id + index}
                                            >
                                              {item.title}
                                            </MenuItem>
                                          )
                                        )}
                                      </Select>
                                    </FormControl>
                                  </Form.Group>
                                  <TextAreaReusableComponent
                                    labelText={"Add Comments"}
                                    placeholder="Add Comments"
                                    onChange={(e) =>
                                      setReason({
                                        ...reason,
                                        blockComments: e.target.value,
                                      })
                                    }
                                  />
                                  <div
                                    style={{ color: "#9E9E9E" }}
                                    className="f12-400"
                                  >
                                    Maximum 150 characters*
                                  </div>
                                </>
                              ) : (
                                <></>
                              )}
                            </Modal.Body>
                            <Modal.Footer className="justify-content-start border-0">
                              <Button
                                variant="outline-secondary"
                                className="btn-lg mr-4 px-5"
                                onClick={handleCloseBlockUser}
                              >
                                {stage === 0 ? "No" : "Cancel"}
                              </Button>
                              <Button
                                variant="danger"
                                className="btn-lg px-5"
                                onClick={() =>
                                  stage === 0 && !props.user.user_blocked
                                    ? changeStage(1)
                                    : blockUser(
                                      props && props.user._id,
                                      props && props.user.user_blocked
                                    )
                                }
                              >
                                {stage === 0 ? "Yes" : "Send"}
                              </Button>
                            </Modal.Footer>
                          </Modal>
                        </React.Fragment>
                      </div>
                    </td>
                    <td colSpan="3" style={{ width: "25%" }}>
                      <div className="mb-2 f15-700">Contact</div>
                      <div className="d-flex align-items-center">
                        <CallingButtonPopup
                          sendData={makeCallingObject(props.user)}
                        />
                        <SuperAdminChatWindowPopup
                          data={props.user}
                          text={"seating"}
                          actionType={"USER"}
                        />
                        <SuperAdminSmsAdmin
                          mobile_number={props.user.mobile_number}
                          first_name={props.user.first_name}
                          country_code={props.user.country_code}
                        />

                        <CustomSuperAdminNotification _id={props.user._id} />
                      </div>
                    </td>
                    <td style={{ width: "15%" }}>
                      <div className="mb-2 f15-700">&nbsp;</div>
                      <NavLink
                        to={`/superadminviewusers/${props.user._id}`}
                        className="f12-500"
                      >
                        <Image
                          src={require("../../../../assets/images/iconButton/right_arrow_green.svg")}
                          alt="View"
                          width="50px"
                          title="View"
                          fluid
                        />{" "}
                        <br />
                        View all
                      </NavLink>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </Fragment>
  );
};

UserModal.propTypes = {
  auth: PropTypes.object.isRequired,
  blockUserFromDetailPage: PropTypes.func.isRequired,
  flagUserFromDetailPage: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  blockUserFromDetailPage,
  flagUserFromDetailPage,
})(UserModal);
